export default __webpack_public_path__ + "static/SectionTwo_02_01-ff19ffe38eb2a7d784a8dff68b2bc49a.webp";